import { PromotionalProductImageProps } from '@coolblue-development/next-patterns/core';
import {
  CollectionName,
  FormattedCollectionName,
  PromotionalContent
} from '@features/product/typings';

const collectionNameMap: Record<CollectionName, FormattedCollectionName | undefined> = {
  Content: 'content',
  Products: 'product',
  Reviews: 'review',
  secondchance: 'second_chance_product',
  Temp: undefined,
  DeliveryInstallation: undefined,
  Animations: undefined
};

// This temporary mapping function is only necessary due to the difference in CollectionName
export function promotionalContentFactory(
  content?: PromotionalContent | null
): PromotionalProductImageProps['promotionalContent'] | undefined {
  if (!content) return undefined;

  const mappedCollectionName: FormattedCollectionName | undefined =
    collectionNameMap[content.promoIcon?.image.collectionName || 'Content'] || 'content';

  // temporary logic to remove specific labels
  const excludedPromoLabels = ['aanbieding', 'promotion', 'offre', 'promotie', 'angebot'];

  const shouldExcludeLabel =
    content.promoIcon?.image.id === '589343' && content.promoLabel?.label
      ? excludedPromoLabels.includes(content.promoLabel.label.toLowerCase())
      : false;

  return {
    ...(content.promoIcon?.image.id && {
      promoIcon: {
        altText: content.promoIcon.altText,
        image: {
          id: content.promoIcon.image.id,
          collectionName: mappedCollectionName
        },
        details: content.promoIcon.details
      }
    }),
    ...(content.promoLabel &&
      !shouldExcludeLabel && {
        promoLabel: {
          ...content.promoLabel
        }
      })
  };
}
